import { useState } from "react";
import { Info, ChevronDown, Wrench, ShieldAlert } from "lucide-react";
import { ADMIN_HELP } from "@/components/admin/adminHelp";

export function AdminHelpBox({ tab, owner }) {
  const h = ADMIN_HELP[tab];
  const [open, setOpen] = useState(!owner);
  if (!h) return null;
  const [what, how, careful] = h;
  return (
    <div className="rounded-2xl border border-sky-200 bg-sky-50/70" data-testid={`admin-help-${tab}`}>
      <button onClick={() => setOpen(!open)} data-testid="admin-help-toggle" className="w-full flex items-center gap-2 px-4 py-3 text-left">
        <Info className="w-4 h-4 text-sky-600 shrink-0" />
        <span className="flex-1 text-sm font-bold text-sky-900">So funktioniert dieser Bereich</span>
        <ChevronDown className={`w-4 h-4 text-sky-600 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="px-4 pb-4 space-y-2.5 text-sm leading-relaxed">
          <p className="text-slate-700"><b>Was ist das?</b> {what}</p>
          <p className="flex gap-2 text-slate-700"><Wrench className="w-4 h-4 mt-0.5 shrink-0 text-sky-600" /><span><b>So gehst du vor:</b> {how}</span></p>
          <p className="flex gap-2 rounded-xl bg-amber-50 border border-amber-200 p-2.5 text-amber-900" data-testid="admin-help-careful"><ShieldAlert className="w-4 h-4 mt-0.5 shrink-0" /><span><b>Wichtig:</b> {careful}</span></p>
        </div>
      )}
    </div>
  );
}
